/** Tab „Barrierefreiheit": reduzierte Bewegung, GIF-Wiedergabe, Einbettungen. */
import { useAppStore } from '../../store/app';
import { patchSettings } from './useSettings';

export function AccessibilityTab() {
  const settings = useAppStore((s) => s.settings);
  if (!settings) return null;
  return (
    <div className="lf-settings-sections">
      <section className="lf-settings-card stack" aria-labelledby="motion-heading">
        <h2 id="motion-heading">Bewegung</h2>
        <label className="switch-row">
          <input type="checkbox" className="switch" checked={settings.reducedMotion} onChange={(e) => void patchSettings({ reducedMotion: e.target.checked })} data-testid="reduced-motion" />
          <span>Bewegung reduzieren (Animationen und Super-Reaktionen aus)</span>
        </label>
        <label className="switch-row">
          <input type="checkbox" className="switch" checked={settings.autoplayGifs} onChange={(e) => void patchSettings({ autoplayGifs: e.target.checked })} data-testid="autoplay-gifs" />
          <span>Animierte Avatare, Emojis und GIFs automatisch abspielen</span>
        </label>
      </section>
      <section className="lf-settings-card stack" aria-labelledby="content-heading">
        <h2 id="content-heading">Inhalte</h2>
        <label className="switch-row">
          <input type="checkbox" className="switch" checked={settings.showEmbeds} onChange={(e) => void patchSettings({ showEmbeds: e.target.checked })} data-testid="show-embeds" />
          <span>Link-Vorschauen anzeigen</span>
        </label>
        <p className="small muted">Schriftgröße und Kontrast (helles Theme „Tageslicht") findest du unter „Darstellung".</p>
      </section>
    </div>
  );
}
